module.exports = __webpack_public_path__ + "img/4-4.595a829f.svg";